import { HashLink } from "react-router-hash-link";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false); // State untuk toggle mobile menu
    const [isProfileOpen, setIsProfileOpen] = useState(false); // State untuk toggle dropdown profil
    const navigate = useNavigate();

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Logo */}
                <Link
                    to="/"
                    className="logo"
                    onClick={() => navigate('/')}
                >
                    <img
                        src="/images/logo.png"
                        alt="Innovatech Logo"
                        className="logo-img"
                        style={{ height: "40px" }}
                    />
                </Link>

                {/* Navigasi Desktop */}
                <div className="nav-links desktop">
                    <HashLink to="/#hero" smooth>Home</HashLink>
                    {/* Dropdown Profil */}
                    <div className="dropdown">
                        <span>Profil</span>
                        <div className="dropdown-content">
                            <HashLink to="/about">About</HashLink>
                            <Link to="/vision-mission">Visi Misi</Link>
                            <HashLink to="/background">Latar Belakang Perusahaan</HashLink>
                            <Link to="/our-service">Our Service</Link> {/* Tambahkan ini */}
                        </div>
                    </div>
                    <HashLink to="/#services" smooth>Services</HashLink>
                    <HashLink to="/#portfolio" smooth>Our Work</HashLink>
                    <HashLink to="/#contact" smooth>Contact</HashLink>
                </div>

                {/* Hamburger Menu */}
                <div
                    className={`hamburger ${isOpen ? 'active' : ''}`}
                    onClick={() => setIsOpen(!isOpen)} // Toggle state
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                {/* Navigasi Mobile */}
                <div className={`nav-links mobile ${isOpen ? 'active' : ''}`}>
                    <HashLink
                        to="/#hero"
                        smooth
                        onClick={() => setIsOpen(false)}
                    >
                        Home
                    </HashLink>
                    {/* Dropdown Profil untuk Mobile */}
                    <div className="dropdown-mobile">
                        <span onClick={() => setIsProfileOpen(!isProfileOpen)}>Profil</span>
                        <div
                            className={`dropdown-content-mobile ${isProfileOpen ? 'active' : ''}`}
                        >
                            <HashLink
                                to="/about"
                                smooth
                                onClick={() => {
                                    setIsOpen(false);
                                    setIsProfileOpen(false); // Tutup dropdown setelah klik
                                }}
                            >
                                About
                            </HashLink>
                            <Link
                                to="/vision-mission"
                                onClick={() => {
                                    setIsOpen(false);
                                    setIsProfileOpen(false); // Tutup dropdown setelah klik
                                }}
                            >
                                Visi Misi
                            </Link>
                            <HashLink
                                to="/background"
                                smooth
                                onClick={() => {
                                    setIsOpen(false);
                                    setIsProfileOpen(false); // Tutup dropdown setelah klik
                                }}
                            >
                                Latar Belakang Perusahaan
                            </HashLink>
                            <Link
                                to="/our-service"
                                onClick={() => {
                                    setIsOpen(false);
                                    setIsProfileOpen(false); // Tutup dropdown setelah klik
                                }}
                            >
                                Our Service
                            </Link>
                        </div>
                    </div>
                    <HashLink
                        to="/#services"
                        smooth
                        onClick={() => setIsOpen(false)}
                    >
                        Services
                    </HashLink>
                    <HashLink
                        to="/#portfolio"
                        smooth
                        onClick={() => setIsOpen(false)}
                    >
                        Our Work
                    </HashLink>
                    <HashLink
                        to="/#contact"
                        smooth
                        onClick={() => setIsOpen(false)}
                    >
                        Contact
                    </HashLink>
                </div>
            </div>
        </nav>
    );
}